export default __webpack_public_path__ + "static/media/(26).352f697b.jpg";